const PRODUCTION_MODE = 'production';

const isProduction = () => process.env.NODE_ENV === PRODUCTION_MODE;

export { isProduction };
